/**
 * navigation/useActiveRoute.ts
 * Reactive current-route name for the sidebar (which lives outside the
 * navigator). Subscribes to the container ref's state changes.
 */
import { useEffect, useState } from 'react';
import { navigationRef } from './navigationRef';
import type { AppRouteName } from './types';

export function useActiveRoute(): AppRouteName | undefined {
  const [route, setRoute] = useState<AppRouteName | undefined>(
    () => (navigationRef.isReady() ? (navigationRef.getCurrentRoute()?.name as AppRouteName) : undefined),
  );

  useEffect(() => {
    const sync = () => {
      if (navigationRef.isReady()) setRoute(navigationRef.getCurrentRoute()?.name as AppRouteName);
    };
    sync();
    const unsub = navigationRef.addListener('state', sync);
    return unsub;
  }, []);

  return route;
}
